module.exports = __webpack_public_path__ + "static/media/url.db3442dc.png";